import React, { MouseEventHandler } from 'react';
import { Table, TableProps } from 'antd';
import ResizeObserver from 'rc-resize-observer';
import { throttle, debounce } from 'lodash';
import _ from 'lodash';
import styled from 'styled-components';
import { TableFieldSetColumn } from '@/component/Report/TableFieldSet/TableFieldSet';

const TableView = styled.div`
  .table-resize-proxy{
    visibility: hidden;
    position: absolute;
    left: 200px;
    top: 0;
    bottom: 0;
    width: 0;
    border-left: 1px solid #dfe6ec;
    z-index: 10;
  }
  .ant-table-wrapper .ant-table-tbody>tr>td{
    padding: 0 10px 0 10px;
    height: 46px;
  }
  .ant-table-wrapper .ant-table-thead>tr>th{
    padding: 0 15px 0 10px; //右边距，实现拖动空间
    height: 46px;
  }
`

interface TableResizeProps  extends TableProps {
  onColumnChange?(columns: TableProps['columns'] ):void
  columns: TableFieldSetColumn[]
}
export const TableResize = (props: TableResizeProps ) => {
  const { ...rest } = props;
  const [height, setHeight] = React.useState(300);
  let setHeightThrottleRef = React.useRef(
    debounce(
      (height: number) => {
        setHeight(height);
      },
      300,
      { trailing: true },
    ),
  );

 
  const updateColumnWidth = (column: TableFieldSetColumn) => {
    // const { setTableColumn, onColumnChange } = props;
    // let columns = _.cloneDeep(props.columns)
    let columns = props.columns
    columns =  columns?.map(item => {
      if ('dataIndex' in item && item.dataIndex === column.dataIndex) {
        item.width = column.width
      }
      return item
    })
    props.onColumnChange && props.onColumnChange(columns)

  }
  const tableRef = React.useRef<HTMLDivElement>(null)
  const { handleMouseDown,handleMouseLeave,handleMouseMove } = useDrag({updateColumnWidth,columns: props.columns,tableRef})

  return (
    <ResizeObserver
      onResize={(e, data) => {
        const { width, height } = e || {};
        setHeightThrottleRef.current(height);
      }}
    >
      <TableView style={{ flex: 1, overflow: 'hidden' }}
        onMouseMove={handleMouseMove}
        onMouseLeave={handleMouseLeave}
        onMouseDown={handleMouseDown}
        ref={tableRef}
      >
        <Table 
          showSorterTooltip={false}
          components={{
            header:{
              cell:Cell
            }
          }}
        className="table-resize" scroll={{ y: height - 50 }} {...rest} />
      </TableView>
    </ResizeObserver>
  );
};
interface CellProps {
  onClick?: MouseEventHandler<HTMLDivElement>
  style?: React.CSSProperties
  children?: React.ReactNode
}
const Cell = (props:CellProps) => {
  const { onClick, style, children, ...restProps } = props;
  return <th {...restProps} style={{ ...style }}>
    <div onClick={onClick} style={{ position: 'relative',whiteSpace:'break-spaces',}}
    >{children}</div>
  </th>
}

interface UseDrageProps {
  updateColumnWidth(column:TableFieldSetColumn):void
  columns: TableFieldSetColumn[]
  tableRef: React.RefObject<HTMLDivElement>
}

const useDrag = (props:UseDrageProps)=>{
  const tableRef = props.tableRef
  const resizeProxyRef = React.useRef<HTMLDivElement|undefined>()
  const draggingRef = React.useRef<boolean>(false)
  const draggingColumnRef = React.useRef<HTMLTableCellElement|undefined>()
  const _document = document
  const columns = props.columns
  const handleMouseLeave:MouseEventHandler<HTMLDivElement>  = (e) => {
    if(draggingColumnRef.current){
      draggingColumnRef.current.style.cursor = ''
    }
  }
  const handleMouseMove:MouseEventHandler<HTMLDivElement> = (event) => {
    if (!draggingRef.current) {
      let target = event.target as HTMLTableCellElement
      // let target = event.target
      const tagName = target.tagName.toLowerCase()
      const parentNode = target.parentNode as HTMLElement
      const ptagName = parentNode?.tagName.toLowerCase()
      const isTh = tagName === 'th'
      if(isTh){
        const rect = target.getBoundingClientRect()

        if (rect.width > 12 && rect.right - event.pageX < 8) {
          target.style.cursor = 'col-resize'
          draggingColumnRef.current = target
        } else {
          target.style.cursor = ''
          draggingColumnRef.current = undefined
        }
      }



      // if (tagName !== 'th' && ptagName !== 'th') {
      //   bodyStyle.cursor = ''
      //   draggingColumnRef.current = null
      //   return
      // }
      // // if (rowSelection && target.cellIndex < 2) {
      // //   return
      // // }
      // if(!parentElement){
      //   return
      // }
      // const rect = parentElement.getBoundingClientRect()

      // if (rect.width > 12 && rect.right - event.pageX < 8) {
      //   parentElement.style.cursor = 'col-resize'
      //   draggingColumnRef.current = parentElement
      // } else {
      //   parentElement.style.cursor = ''
      //   draggingColumnRef.current = null
      // }
    }
  }
  React.useEffect(()=>{
    const tableContent =  tableRef.current?.getElementsByClassName('ant-table')[0]
    const div = resizeProxyRef.current = document.createElement('div')
    div.className = 'table-resize-proxy'
    tableContent?.appendChild(div)
  },[])
  const handleMouseDown:MouseEventHandler<HTMLDivElement> = (event) => {
    if (draggingColumnRef.current) {
      draggingRef.current = true
      const tableEl = tableRef.current?.getElementsByClassName('ant-table')[0]
      // const { rowSelection, columns = [] } = props
      const resizeProxy = resizeProxyRef.current
      if(!tableEl){
        return
      }
      // const { tableContent: tableEl, resizeProxy } = this
      const tableLeft = tableEl.getBoundingClientRect().left

      let columnEl = draggingColumnRef.current

      // let column = rowSelection ? columns[columnEl.cellIndex - 1] : columns[columnEl.cellIndex]
      let column =  columns[columnEl.cellIndex]
      if(!column){
        draggingColumnRef.current = undefined
        return 
      }
      column = {...column}

      const columnRect = columnEl.getBoundingClientRect()
      const minLeft = columnRect.left - tableLeft + 30

      const startMouseLeft = event.clientX
      const startLeft = columnRect.right - tableLeft
      const startColumnLeft = columnRect.left - tableLeft

      resizeProxy && (resizeProxy.style.visibility = 'visible')
      resizeProxy && (resizeProxy.style.left = startLeft + 'px')

      _document.onselectstart = () => false
      _document.ondragstart = () => false

      const handleMouseMove  = (event: MouseEvent) => {
        const deltaLeft = event.clientX - startMouseLeft
        const proxyLeft = startLeft + deltaLeft

        resizeProxy && (resizeProxy.style.left = Math.max(minLeft, proxyLeft) + 'px')
      }

      const handleMouseUp = (event:MouseEvent) => {
        if (draggingRef.current) {
          const finalLeft = parseInt(resizeProxy?.style.left || '0', 10)
          const columnWidth = finalLeft - startColumnLeft
          // const oldWidth = column.realWidth;
          // column.width = column.realWidth = columnWidth
          column.width = Math.max(columnWidth,60)

          draggingRef.current = false
          draggingColumnRef.current = undefined

          _document.body.style.cursor = ''
          resizeProxy && (resizeProxy.style.visibility = 'hidden')
          _document.removeEventListener('mousemove', handleMouseMove)
          _document.removeEventListener('mouseup', handleMouseUp)
          _document.onselectstart = null
          _document.ondragstart = null

          props.updateColumnWidth(column)
        }
      }

      _document.addEventListener('mousemove', handleMouseMove)
      _document.addEventListener('mouseup', handleMouseUp)
    }
  }


  return {
    handleMouseDown,
    handleMouseMove,
    handleMouseLeave,
  }
}